import React, { Component, Fragment } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { Layout } from 'antd';
import HomeV2 from './Home.v2';
import About from './About';
import PageHeader from './components/PageHeader';
import PageFooter from './components/PageFooter';
import Cache from './services/CacheService';
import CompressToSize from './components/CompressToSize';
import CompressionModeContextProvider from './context/CompressionModeContextProvider';
import './css/App.css';
import './css/About.css';
import './css/Slider.css';
import './css/FileTable.css';
import './css/ImageComparison.css';
import './css/Components.css';
import './css/Home.css';
import './css/ActionBar.css';
import './css/Nav.css';
import './css/CompressToSize.css';
import './css/Antd.css';

const { Content } = Layout;

class App extends Component {
	homePage = () => {
		return (
			<Layout>
				<PageHeader historyCount={Cache.HistoryCount} />
				<Route
					exact
					path="/compress"
					render={() =>	{
						return (
							<Redirect to="/" />
						);
					}
					}
				/>
				<Route
					exact
					path="/"
					render={() => {
						return (
							<Content>
								<CompressionModeContextProvider>
									<HomeV2 />
								</CompressionModeContextProvider>
							</Content>
						);
					}}
				/>
				<Route
					exact
					path="/compress-to-exact-size"
					render={() => {
						return (
							<Fragment>
								<Content>
									<CompressToSize />
								</Content>
								<PageFooter />
							</Fragment>
						);
					}}
				/>
				<Route
					exact
					path="/about"
					render={() => {
						return (
							<Fragment>
								<Content>
									<About />
								</Content>
								<PageFooter />
							</Fragment>
						);
					}}
				/>
			</Layout>
		);
	};
	render() {
		return this.homePage();
	}
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js